/**
 * Cross-route hand-off for "open this Agent in /chat".
 *
 * The `/agents` page lets the user click "Chat" on any Agent card,
 * which routes to `/chat` via `next/navigation`. Because `/chat` does
 * its own bootstrap (load agents → pick a default), we drop the
 * desired Agent id into `sessionStorage` and the chat page consumes
 * (and clears) it on mount. `sessionStorage` over query params keeps
 * the URL clean and avoids surviving a copy-paste / bookmark — the
 * preselect is intentionally one-shot.
 */

const KEY = "kos:chat:preselect-agent-id";

export function setChatPreselectedAgentId(id: string): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(KEY, id);
  } catch {
    /* sessionStorage can throw in private modes / quota limits */
  }
}

/** Read once and clear. Safe to call during render-effect on the chat page. */
export function consumeChatPreselectedAgentId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.sessionStorage.getItem(KEY);
    if (v) window.sessionStorage.removeItem(KEY);
    return v ?? null;
  } catch {
    return null;
  }
}
